import FormControl from "@material-ui/core/FormControl";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import Radio from "@material-ui/core/Radio";
import RadioGroup from "@material-ui/core/RadioGroup";
import Switch from "@material-ui/core/Switch";
import { useEffect, useState } from "react";
import { useHistory, useParams } from "react-router-dom";
import useDocumentTitle from "../../utils/useDocumentTitle";

import styles from "./Settings.module.scss";

import { useTranslation } from "react-i18next";
import BackButton from "../../components/BackButton";
import EditSubjectsTabs from "../../components/EditSubjectsTabs";
import PageContent from "../../components/PageContent";
import Section from "../../components/Section";
import SectionTitle from "../../components/SectionTitle";
import { useNotification } from "../../context/notification";
import { DashboardLayout } from "../../layouts/DashboardLayout";
import { apiRequest } from "../../utils/api";
import { getLocalValue } from "../../utils/auth";
import { getQueryVariable } from "../../utils/getQueryParam";

export function EditSubject(props) {
  useDocumentTitle(props.title);
  const { t } = useTranslation();
  const history = useHistory();
  const { id } = useParams();
  const { addNotification } = useNotification();
  const editSubjectFor = getQueryVariable("subjectFor");
  const userId = getLocalValue("uid");
  const user_role = getLocalValue("u_coaching_role_db");
  const [campaignData, setCampaignData] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  const [userStatus, setUserStatus] = useState(true);
  const [subjectFor, setSubjectFor] = useState(editSubjectFor);

  async function fetchData() {
    setIsLoading(true);

    const response = await apiRequest.get(
      `/api/getSubjectManagementCampaignDetailsById?campaign_id=${id}`
    );

    if (response.status === 200) {
      let data = response.data.data;
      setCampaignData(data);
      setUserStatus(data[0].status === 1 ? true : false);
    } else {
      addNotification(
        t("error.couldNotGetSession") + ` (Status code: ${response.status})`,
        "error"
      );
    }
    setIsLoading(false);
  }

  useEffect(() => {
    fetchData();
  }, []);

  const getCampaignInfo = field => {
    return campaignData && campaignData[0] ? campaignData[0][field] : null;
  };

  //Handling Subject for Change
  const handleChange = event => {
    setSubjectFor(event.target.value);
  };

  return (
    <DashboardLayout>
      <div className={styles.pageWrapper}>
        <PageContent>
          <Section>
            <div className={styles.profileContainer}>
              <div className={styles.backButtonWrapper}>
                <BackButton />
              </div>
              <div className={styles.profileWrapper}>
                <SectionTitle>
                  {" "}
                  {t("subjectManagement.editSubject")}
                </SectionTitle>
                {campaignData && (
                  <form>
                    <div className={styles.detailsContainer}>
                      <div className={styles.profileRow}>
                        <div className={styles.rowLeft}>
                          {" "}
                          {t("subjectManagement.department")}
                        </div>
                        <div className={styles.rowRight}>
                          {getCampaignInfo("department")}
                        </div>
                      </div>
                      {getCampaignInfo("sub_functional_unit") && (
                        <div className={styles.profileRow}>
                          <div className={styles.rowLeft}>
                            {" "}
                            {t("subjectManagement.functionalUnit")}
                          </div>
                          <div className={styles.rowRight}>
                            {getCampaignInfo("sub_functional_unit")}
                          </div>
                        </div>
                      )}
                      <div className={styles.profileRow}>
                        <div className={styles.rowLeft}>
                          {" "}
                          {t("subjectManagement.country")}
                        </div>
                        <div className={styles.rowRight}>
                          {getCampaignInfo("country_name")}
                        </div>
                      </div>
                      <div className={styles.profileRow}>
                        <div className={styles.rowLeft}>
                          {" "}
                          {t("subjectManagement.subjectFor")}
                        </div>
                        <div className={styles.rowRight}>
                          <FormControl
                            component="fieldset"
                            style={{ width: "100%" }}
                          >
                            <RadioGroup
                              aria-label="role"
                              className={styles.subjectFor}
                              name="role"
                              value={subjectFor}
                              onChange={handleChange}
                              row
                            >
                              <FormControlLabel
                                className={styles.labelOption}
                                value="2"
                                control={
                                  <Radio className={styles.radioOption} />
                                }
                                label="Agent"
                              />
                              <FormControlLabel
                                className={styles.labelOption}
                                value="1"
                                control={
                                  <Radio className={styles.radioOption} />
                                }
                                label="Team Lead"
                              />
                            </RadioGroup>
                          </FormControl>
                        </div>
                      </div>

                      <div className={styles.profileRow}>
                        <div className={styles.rowLeft}>
                          {" "}
                          {t("subjectManagement.status")}
                        </div>
                        <div className={styles.rowRight}>
                          <FormControlLabel
                            control={
                              <Switch
                                checked={userStatus}
                                onChange={e => {
                                  setUserStatus(e.target.checked);
                                }}
                                name="userStatus"
                              />
                            }
                            label={userStatus ? "Active" : "Inactive"}
                          //active: 1
                          //inactive: 0
                          />
                        </div>
                      </div>
                    </div>
                    {campaignData && campaignData.length && (
                      <div className={styles.profileRow}>
                        <EditSubjectsTabs
                          campaignData={campaignData[0]}
                          subjectFor={subjectFor}
                          status={userStatus}
                          userId={userId}
                          userRole={user_role}
                        />
                      </div>
                    )}
                  </form>
                )}
                <div></div>
              </div>
            </div>
          </Section>
        </PageContent>
      </div>
    </DashboardLayout>
  );
}
